import React, { useEffect, useState, useCallback, useMemo } from 'react';
import NavigationHeader from "../Layout/NavigationHeader";
import {useParams} from "react-router-dom";
import {getSessionInfo} from '../../common/BackendConnections';
import {createMarkup, valueOrDash} from '../../common/utils/dom_utils'

import './PatientSessionsComparison.css';

// ----------------------------------------------------------------------------
const getSessionInfoDetails = (sessionID) => {
  return getSessionInfo(sessionID)
    .then((response) => {
        return response;
      }
    )
    .catch((function(err) { console.log('fetch error from getSessionList' + err); })
    );
}

function sessionIdList (item1, item2){
  return [item1, item2];
}

const PatientSessionsComparison = (props) => {
  
  const [sessionDetails0, setSessionDetails0] = useState(undefined);
  const [sessionDetails1, setSessionDetails1] = useState(undefined);

  let parameters = useParams();
  let sessionId01 = parameters["sessionId01"];
  let sessionId02 = parameters["sessionId02"]
 
  const assignedSessionIds = useMemo(() => sessionIdList(sessionId01, sessionId02), [sessionId01, sessionId02]);

  const createSessionDetails = useCallback( () => {
    for (let [sessionIndex, sessionId] of assignedSessionIds.entries()) {
      getSessionInfoDetails(sessionId).then((response) => {
        const sessionData = response.data;
        //const loadedUsers = [];
        const localDate = new Date(sessionData.datetime_iso8601);
        const loadedUsers = {
          patient_id: sessionData.patient_id,
          patient_name: sessionData.patient_name,
          scene_id: sessionData.scene_id,
          scene_name: sessionData.scene_name,
          session_id: sessionData.session_id,
          observer_id: sessionData.observer_id,
          observer_name: sessionData.observer_name,
          datetime: sessionData.datetime_iso8601,
          id: sessionData.session_short_id,
          device_id: sessionData.device_id,
          device_name: sessionData.device_name,
          info: sessionData.info,
          note: sessionData.note,
          date: `${localDate.toLocaleDateString()}`,
          time: `${localDate.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}`
        };
        handleAddSessionDetail(sessionIndex, loadedUsers);
      }).catch(function(err) { console.log('fetch error from createSessionDetails\n' + err); })
    }
  }, [assignedSessionIds])

  useEffect(() => {
    createSessionDetails();
  }, [createSessionDetails]);

  const handleAddSessionDetail = (sessionIndex, sessionToAdd) => {
    switch (sessionIndex) {
      case 0:
        setSessionDetails0(sessionToAdd);
        break;
      case 1:
        setSessionDetails1(sessionToAdd);
        break;
      default:
        console.log(`Unhandled case in patient sessions comparison`, sessionIndex);
    }
  };

  // ----------------------------------------------------------------------------
  const sessionDetails = [sessionDetails0, sessionDetails1];
  return (
    <div className={"page_content"}>
      <NavigationHeader />

      <div>
        <span className={"faded_text"}>
          Patient Sessions {'>'} Session Comparison
        </span>
        <h1>Session Comparison</h1>
        <div>
          { (sessionDetails[0]  && sessionDetails[1])
          ?
          <div >
            
          <table className= {"styled-table"}>
              <thead>
              <tr>
                <th></th>
                <th className={"cell-styled"}>ID# {sessionDetails[0].id} </th>
                <th className={"cell-styled"}>ID# {sessionDetails[1].id} </th>
                {/*<th className={"cell-styled"}>Comparison </th>*/}
              </tr>
              <tr className={"cell-styled"}>
                <th>General Information</th>
                <th></th>
                <th></th>
                {/*<th></th>*/}
              </tr>
              </thead>

              <tbody>
              <tr >
                <td className={"cell-styled"}>Game</td>
                <td className={"cell-styled"}>{sessionDetails[0].scene_name}</td>
                <td className={"cell-styled"}>{sessionDetails[1].scene_name}</td>
                {/*<td className={"cell-styled"}></td>*/}
              </tr>
              <tr>
                <td className={"cell-styled"}>Observer</td>
                <td className={"cell-styled"}>{sessionDetails[0].observer_name}</td>
                <td className={"cell-styled"}>{sessionDetails[1].observer_name}</td>
                {/*<td className={"cell-styled"}></td>*/}
              </tr>
              <tr>
                <td className={"cell-styled "}>Platform</td>
                <td className={"cell-styled "}>{valueOrDash(sessionDetails[0].device_name)}</td>
                <td className={"cell-styled "}>{valueOrDash(sessionDetails[1].device_name)}</td>
                {/*<td className={"cell-styled "}></td>*/}
              </tr>
              <tr>
                <td className={"cell-styled "}>Date</td>
                <td className={"cell-styled "}>{sessionDetails[0].date}</td>
                <td className={"cell-styled "}>{sessionDetails[1].date}</td>
                {/*<td className={"cell-styled "}></td>*/}
              </tr>
              <tr>
                <td className={"cell-styled "}>Time</td>
                <td className={"cell-styled "}>{sessionDetails[0].time}</td>
                <td className={"cell-styled "}>{sessionDetails[1].time}</td>
                {/*<td className={"cell-styled "}></td>*/}
              </tr>
              {/*<tr>*/}
              {/*  <td className={"cell-styled "}>Register #</td>*/}
              {/*  <td className={"cell-styled "}>{sessionId01}</td>*/}
              {/*  <td className={"cell-styled "}>{sessionId02}</td>*/}
              {/*  <td className={"cell-styled "}></td>*/}
              {/*</tr>*/}

              <tr className={"cell-styled"}>
                <th>Session Information</th>
                <th></th>
                <th></th>
                {/*<th></th>*/}
              </tr>

              <tr>
                <td className={"cell-styled "}></td>
                <td className={"cell-styled "}><div dangerouslySetInnerHTML={createMarkup(valueOrDash(sessionDetails[0].info))}/></td>
                <td className={"cell-styled "}><div dangerouslySetInnerHTML={createMarkup(valueOrDash(sessionDetails[1].info))}/></td>
                {/*<td className={"cell-styled "}></td>*/}
              </tr>

              <tr className={"cell-styled"}>
                <th>Notes</th>
                <th></th>
                <th></th>
                {/*<th></th>*/}
              </tr>
              <tr>
                <td className={"cell-styled "}></td>
                <td className={"cell-styled "}><div dangerouslySetInnerHTML={createMarkup(valueOrDash(sessionDetails[0].note))}/></td>
                <td className={"cell-styled "}><div dangerouslySetInnerHTML={createMarkup(valueOrDash(sessionDetails[1].note))}/></td>
                {/*<td className={"cell-styled "}></td>*/}
              </tr>
              </tbody>
            </table>

          </div>

          :
            <h2> The selected sessions have failed to load their data for dispaly. </h2>
          }
         
        </div>

      </div>
    </div>
  );
}

export default PatientSessionsComparison;
